import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';

import React from 'react';
import ReactDOM from 'react-dom';
import Terms from './components/Terms';
import Home from './components/home';
import Search from './components/Search';
import Menu from './components/menu';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { LocalizeProvider } from "react-localize-redux";
import * as serviceWorker from './serviceWorker';
import './sass/App.scss';
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'jquery/dist/jquery.js';
import 'popper.js/dist/popper.js';
import 'bootstrap/dist/js/bootstrap.js';
import 'github-markdown-css/github-markdown.css';
import 'prismjs/components/prism-csharp';
import 'prismjs/components/prism-sql';
import 'prismjs/themes/prism-tomorrow.css';

import $ from 'jquery';

class Main extends React.Component {

  constructor(props) {
    super(props);

    this.state = { urls: [] };

    // Close any open menu accordions when window is resized below 768px
    $(window).resize(function () {
      if ($(window).width() < 768) {
        $('.sidebar .collapse').collapse('hide');
      };
    });

    // Prevent the content wrapper from scrolling when the fixed side navigation hovered over
    $('body.fixed-nav .sidebar').on('mousewheel DOMMouseScroll wheel', function (e) {
      if ($(window).width() > 768) {
        var e0 = e.originalEvent,
          delta = e0.wheelDelta || -e0.detail;
        this.scrollTop += (delta < 0 ? 1 : -1) * 30;
        e.preventDefault();
      }
    });

    // Scroll to top button appear
    $(document).on('scroll', function () {
      var scrollDistance = $(this).scrollTop();
      if (scrollDistance > 100) {
        $('.scroll-to-top').fadeIn();
      } else {
        $('.scroll-to-top').fadeOut();
      }
    });
  }

  componentDidMount() {
    var root = `${process.env.PUBLIC_URL}/markdown`;
    fetch(`${root}/config.json?v=1.045`).then((response) => response.text()).then((text) => {
      var pages = JSON.parse(text);
      var ur = []
      pages.Pages.forEach(element => {
        ur.push(element);
      });

      this.setState({ urls: ur });
    });
  }


  render() {
    var routers = this.state.urls.map((u) => {
      return (<Route key={u.Route} exact path={u.Route} component={() => <Terms path={u.Path} />} />);
    });

    routers.push(<Route key="/Search" exact path="/Search" component={() => <Search />} />);
    routers.push(<Route key="/Home" exact path="/" component={() => <Home />} />);

    return (
      <LocalizeProvider>
        <Router>
          <div id="wrapper">
            <Menu />
            <Switch>
              {
                routers
              }
            </Switch>
            <a className="scroll-to-top rounded" href="#page-top">
              <i className="fas fa-angle-up"></i>
            </a>
          </div>
        </Router>
      </LocalizeProvider>
    );
  }


}

ReactDOM.render(<Main />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
